var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEdit = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Template---Upper-Bar",
    transform: "translate(-902.000000, -14.000000)",
    fill: "#F9F9F9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M919,16.6539302 C918.999349,15.9436953 918.721711,15.276391 918.218142,14.7748428 C917.179563,13.740359 915.491126,13.7417856 914.453717,14.7787337 L903.737287,25.5200633 C903.388712,25.8677879 903.122637,26.2982607 902.967772,26.7650495 L902.957768,26.7953992 L902,31 L906.223431,30.0560465 L906.254872,30.0456705 C906.722583,29.8910686 907.154046,29.6257033 907.50353,29.2769412 L918.22139,18.5343146 C918.724049,18.0318584 919.000648,17.3640353 919,16.6539302 Z M904.342063,29.1165028 L903.89423,28.669169 L904.2176,27.249218 L905.767932,28.7978309 L904.342063,29.1165028 Z M917.280121,17.5971055 L906.874979,28.0263779 L904.990753,26.1441777 L912.11828,19.0001954 L913.203629,20.0837057 L914.143599,19.1453293 L913.0563,18.0598736 L914.067466,17.0465308 L915.156713,18.133932 L916.096682,17.1955556 L915.005486,16.1062089 L915.394856,15.7159429 C915.913885,15.1971446 916.759273,15.1963664 917.279212,15.7142567 C917.531256,15.9653551 917.67027,16.2994612 917.67066,16.6549678 C917.67092,17.010604 917.532555,17.3448398 917.280121,17.5971055 Z M908.99306,29.6585173 L918.999999,29.6585173 L918.999999,30.9856033 L907.668269,30.9856033 L908.99306,29.6585173 Z",
    id: "Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEdit, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/edit.1125f145.svg";
export { ForwardRef as ReactComponent };